<section>
  <h3>Deseja remover este endereço da sua lista?</h3>
  <div class="d-flex gap-3">
    <button class="confirm-button" (click)="deleteAddress()">Confirmar</button>
    <button class="cancel-button" (click)="close()">Voltar</button>
  </div>
</section>
